import mainStore from '@components/Main/store'
import {
  DECORATION_JIA_MENG_MODULES,
  DECORATION_SHOP_INFO,
  EDIT_IMG,
  EDIT_STORE_PATH,
  PRO_DECORATION_MODULE,
  PROPERTY_WEDDING_PLAN_ID,
  DECORATION_MERCHANT_VIDEO,
  SERVICE_UPGRADE,
  SERVICE_CONFIG
} from '@constant'
import { isStoreAccount, getMerchantInfo } from '@util'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import style from '../../style.module.less'
import { EditIcon, RejectIcon, VerifyingIcon } from './EditorIcon'
import { Modal } from 'hljd'
import { hashHistory } from 'react-router'
import {
  SERVICE_CONFIG_PATH,
  UPGRADE_SERVICE_PATH
} from '@components/Hotel/constant'

class Editting extends Component {
  getContent = (isProModule, isStore, isEditting, type) => {
    const normalBg = 'rgba(68, 138, 252, 0.3)'
    const normalBorder = '2px solid #448afe'

    if (isStore) {
      return {
        bg: normalBg,
        border: isEditting ? normalBorder : 'none',
        img: (
          <div
            style={{
              height: 36,
              backgroundColor: '#fff',
              borderRadius: 18,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#448AFC',
              padding: '5px 20px'
            }}
          >
            <img src={EDIT_IMG} style={{ marginRight: 5 }} />
            {DECORATION_JIA_MENG_MODULES[type]}
          </div>
        )
      }
    }
    return {
      bg: isProModule ? 'rgba(232, 180, 94, 0.3)' : normalBg,
      border: isEditting
        ? isProModule
          ? '2px solid #e19d2d'
          : normalBorder
        : 'none',
      img: <EditIcon isPro={isProModule} type={type} />
    }
  }

  // 判断当前类别是否是店铺服务（收费）
  getItemIsProModule = type => {
    const { property_id } = getMerchantInfo()
    // 婚策类目视频模块属于店铺服务（收费）
    if (
      type === DECORATION_MERCHANT_VIDEO &&
      property_id === PROPERTY_WEDDING_PLAN_ID
    ) {
      return true
    }
    return PRO_DECORATION_MODULE.indexOf(type) > -1
  }

  render() {
    const { currentEditting, type, status, position } = this.props
    const isProModule = this.getItemIsProModule(type)
    const isStore = isStoreAccount()
    const isEditting = currentEditting === type
    const { bg, border, img } = this.getContent(
      isProModule,
      isStore,
      isEditting,
      type
    )

    return (
      <>
        <div
          className={style.editting}
          style={{
            backgroundColor: bg,
            border
          }}
        />
        <div className={style[position]}>
          {status === 'rejected' && <RejectIcon />}

          {status === 'verifying' && <VerifyingIcon />}

          {!status && img}
        </div>
      </>
    )
  }
}

@observer
export default class extends Component {
  static defaultProps = {
    vCenter: true,
    disableEdit: false,
    position: 'center'
  }

  componentDidMount() {
    const {
      store: { urlEditting },
      type
    } = this.props
    if (urlEditting == type) {
      const ref = this[`${type}Ref`]
      setTimeout(() => {
        mainStore.scrollTopMain(0, ref.getBoundingClientRect().top - 64)
        const val = mainStore.contentMainDiv.current.scrollTop
        const el = document.querySelector('#decoration-edit')
        el.style.marginTop = `${val - 80}px`
      })
    }
  }

  onClick = () => {
    if (this.props.store.mode != 'editable') {
      return
    }
    switch (this.props.type) {
      case DECORATION_SHOP_INFO:
        this.shopInfoHandler()
        break
      case SERVICE_CONFIG:
        hashHistory.push(SERVICE_CONFIG_PATH)
        break
      case SERVICE_UPGRADE:
        hashHistory.push(UPGRADE_SERVICE_PATH)
        break
      default:
        this.props.store.changeCurrentEditting(this.props.type)
    }
  }

  shopInfoHandler = () => {
    const { examine, is_opened_trade } = getMerchantInfo()
    // 店铺审核未通过或未交店铺服务费的不能编辑
    if (examine != 1 || !is_opened_trade) {
      return Modal.info({
        title: '店铺处于入驻审核阶段，不可编辑店铺信息'
      })
    }
    hashHistory.push(EDIT_STORE_PATH)
  }

  render() {
    const {
      store: { currentEditting, mode, themeConfig },
      type,
      title,
      content,
      children,
      status,
      vCenter,
      position,
      style: customStyle,
      disableEdit
    } = this.props

    const color = themeConfig['text']
    return (
      <div
        ref={ref => (this[`${type}Ref`] = ref)}
        className={style.rowbox}
        style={{
          alignItems: vCenter && 'center',
          backgroundColor: themeConfig['bg'],
          ...customStyle
        }}
        onClick={() => {
          if (!disableEdit) {
            this.onClick()
          }

          const { onClick } = this.props
          onClick && onClick()
        }}
      >
        {children ? (
          children
        ) : (
          <>
            {title && (
              <div
                style={{
                  width: 50,
                  marginRight: 10,
                  color,
                  border: `1px solid ${color}`
                }}
                className="text-center"
              >
                {title}
              </div>
            )}

            {content && <div style={{ flex: 1 }}>{content}</div>}
          </>
        )}

        {!disableEdit &&
          mode === 'editable' && (
            <Editting
              currentEditting={currentEditting}
              type={type}
              status={status}
              position={position}
            />
          )}
      </div>
    )
  }
}
